export class Employee {
    $key : string;
    vote : string;
    ipadress : string;
    code: string;
}
